import { render, staticRenderFns } from "./BHhome.vue?vue&type=template&id=31b31f2b&scoped=true&"
import script from "./BHhome.vue?vue&type=script&lang=js&"
export * from "./BHhome.vue?vue&type=script&lang=js&"
import style0 from "./BHhome.vue?vue&type=style&index=0&id=31b31f2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b31f2b",
  null
  
)

export default component.exports